module.exports = __webpack_public_path__ + "static/media/face-female-1.16d09359.jpg";